import { currencySymbol } from '../ui/price';
import { EditableLine } from './EditableText';
import { priceInput, priceText, type Edits } from './useItemEdits';
import type { Item } from '../db/schema';

/**
 * `$248`, under its own section label. The price is editable in place like
 * everything else here.
 *
 * The symbol sits outside the field because the field holds a number you can
 * type into. Grouping and decimals belong to the tile caption, which only ever
 * displays.
 *
 * The source link used to live on this row as `· westelm.com ↗`. It moved to
 * its own section — see `SourceLink` — once every item could have one, rather
 * than only the imported ones.
 */
export function Meta({ item, edits }: { item: Item; edits: Edits }) {
  return (
    <section className="panel__section">
      <h3 className="section-label">Price</h3>

      <div className="panel__meta">
        <span className="panel__currency" aria-hidden="true">
          {currencySymbol(item.currency)}
        </span>

        <EditableLine
          className="panel__price"
          value={edits.value('price', priceText(item.price))}
          label={item.currency === undefined ? 'Price' : `Price in ${item.currency}`}
          placeholder="Add a price"
          inputMode="decimal"
          onChange={(next) => edits.set('price', priceInput(next))}
          onCommit={() => edits.commit('price')}
        />
      </div>
    </section>
  );
}
